
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, Collapse, Nav, NavItem, FormControl, Form, FormGroup, ControlLabel, Col, Panel, Row, ButtonGroup, Button } from 'react-bootstrap';
import Select from 'react-select';
import CardHeader from './card-header.js';
import Card from './card.js';
import CardBody from './card-body.js';
import $ from 'jquery';
import TranslationTable from './tables/translation-table.js';
import UpdateTable from './tables/update-table.js';
import TranslationEdit from './forms/translation-edit.js';
import InsertTranslation from './forms/insert-translation-form.js';
import AddTranslation from './forms/add-new-translation-form.js';
import TranslationService from '../services/translation-service.js';
import TranslationStore from '../store/translation-store.js';
import AllLanguageSelector from "./inputs/all-language-selector.js";
import Download from '../classes/download.js';


export default class TranslationSystem extends React.Component {

    constructor(props) {
        super();

        this.props = props;
        this.state = {
            curriculumRelevant: true,
            selectedVocab: [],
            curriculums: [],
            data: [],
            edit: false,
            showUnappliedChanges: false,
            newTranslation: false,
            transUid: undefined,
            newTransPopUp: false,
            newTranslationUid: undefined,
            appliedChanges: false
            
        };
        this.table = undefined;
        this.search = "";
        this.uid = "";

        this.VOCAB_ENUM = "Vocab";
        this.TRANSLATIONS_ENUM = "Translations";
        this.MODULE_TRANSLATIONS_ENUM = "Module Translations";
        this.SENTENCE_BUILDING_ENUM = "Grammar";
        this.SENTENCE_BUILDING_CATALOG_ENUM = "Sentence Building Catalog";
        this.ALL_ENUM = "All";
        this.TRUE_ENUM = "True";
        this.FALSE_ENUM = "False";
    }

    componentDidMount() {
        TranslationService.getAllCurriculums();
    }

    componentWillMount() {
        TranslationStore.on("CHANGE", () => {
            this.setState({
                curriculums: TranslationStore.curriculums,
                data: TranslationStore.data,
                unappliedChanges: TranslationStore.unappliedChanges,
                isLoading: false,
                newTranslationUid: TranslationStore.newTranslationUid,
                newTransPopUp: TranslationStore.newTranslationUid != undefined,

            });
            if (this.table != undefined) {
                if (this.typeOption == "Vocab") {
                    this.table.setIsPlain(false);
                } else {
                    this.table.setIsPlain(true);
                }
                if (this.table != undefined) {
                    this.table.setData(this.state.data);
                }
            }

            if (this.updateTable != undefined) {
                this.updateTable.setData(this.state.unappliedChanges)
            }
        });
    }

    renderType() {
        var types = [this.VOCAB_ENUM , this.TRANSLATIONS_ENUM, this.MODULE_TRANSLATIONS_ENUM , this.SENTENCE_BUILDING_ENUM, this.SENTENCE_BUILDING_CATALOG_ENUM];

        types = types.map(function (type) {
            return { value: type, label: type }
        });

        if (this.typeOption == undefined) {
            this.typeOption = types[0];
        }

        if (this.typeOption == this.VOCAB_ENUM  && this.table != undefined) {
            this.table.setIsPlain(false);
        } else if (this.table != undefined) {
            this.table.setIsPlain(true);
        }

        return <Select onChange={this.typeSelect.bind(this)} options={types} value={this.typeOption} noResultsText={<FormattedMessage id={"ui-2011"} defaultMessage={"No Results Found"} />}
            placeholder={<FormattedMessage id={'ui-892'} defaultMessage={'Select'} />} />
    }

    typeSelect(e) {
        this.typeOption = e.value;
        if (this.typeOption == this.VOCAB_ENUM || this.typeOption ==  this.SENTENCE_BUILDING_ENUM) {
            this.setState({ curriculumRelevant: true });
        } else {
            this.setState({ curriculumRelevant: false });
        }
    }

    renderCurriculum() {

        var curriculums = [];
        if (this.state.curriculums != null && this.state.curriculums != undefined) {
            var curriculums = this.state.curriculums.map(function (curr) {
                return { value: curr.note, label: curr.note }
            });
        } 

        if (this.currOption == undefined) {
            this.currOption = curriculums[0];
        }

      /*   if (this.langSelect != undefined && this.currOption != undefined) {
            this.langSelect.setCurr(this.currOption.uid);
        } */

        return <Select onChange={this.currSelect.bind(this)} options={curriculums} value={this.currOption} noResultsText={<FormattedMessage id={"ui-2011"} defaultMessage={"No Results Found"} />}
            placeholder={<FormattedMessage id={'ui-892'} defaultMessage={'Select'} />} />
    }

    currSelect(e) {
        this.currOption = e.value;
        this.setState({})
    }

    renderLanguage() {
        return <AllLanguageSelector ref={(langSelector) => this.langSelect = langSelector} onSelect={this.languageSelect.bind(this)} addAll={true} />
    }

    languageSelect(e) {
        this.selectedLanguage = e.ietf;
    }

    renderIsLive() {
        var isLiveTypes = [this.ALL_ENUM , this.TRUE_ENUM, this.FALSE_ENUM];

        isLiveTypes = isLiveTypes.map(function (type) {
            return { value: type, label: type }
        });

        if (this.isLiveOption == undefined) {
            this.isLiveOption = isLiveTypes[0];
        }

        return <Select onChange={this.isLiveSelect.bind(this)} options={isLiveTypes} value={this.isLiveOption} noResultsText={<FormattedMessage id={"ui-2011"} defaultMessage={"No Results Found"} />}
            placeholder={<FormattedMessage id={'ui-892'} defaultMessage={'Select'} />} />
    }

    isLiveSelect(e) {
        this.isLiveOption = e.value;
        this.setState({});
    }


    renderFilters() {
        if (this.state.curriculumRelevant) {
            var selection = [{ type: '', obj: this.renderType() }, { type: '', obj: this.renderCurriculum() }, { type: '', obj: this.renderLanguage() }, { type: '', obj: this.renderIsLive() }];
        } else {
            var selection = [{ type: '', obj: this.renderType() }, { type: '', obj: this.renderLanguage() }, { type: '', obj: this.renderIsLive() }];
        }
        return selection.map(function (item) {
            return <Col sm={6}> {item.type}{item.obj}</Col>
        });
    }

    onSubmit() {
        var type = this.typeOption;
        if (type.label != undefined) {
            type = type.label;
        }
        var language = this.selectedLanguage || 'en';
        var curr = null;
        if (this.currOption != undefined) {
            curr = this.currOption;
        }
        if (language == "All" && curr == "All") {


        } else {
            TranslationService.getData(type, language, curr, this.uid, this.search, this.isLiveOption.label);
            this.setState({
                isLoading: true,
                showUnappliedChanges: false
            });
        }

    }

    renderSelect() {
        return React.createElement(Button, {
            onClick: this.onSubmit.bind(this),
            bsStyle: 'primary',
            className: "btn-block",
        }, "Submit");
    }

    renderNewTranslation() {
        return React.createElement(Button, {
            onClick: this.addNewTranslationFunction.bind(this),
            bsStyle: 'primary',
            className: "btn-block",
        }, "Add New Translation");
    }

    renderAddTranslationButton() {

        return React.createElement(Button, {
            onClick: this.addNewTranslationFunctionExisitngUid.bind(this),
            bsStyle: 'primary',
            className: "btn-block",
        }, "Add New Translation for Exisiting Uid");
    }

    renderAddTranslation() {

        return <div>{this.renderAddTranslationButton()}
            <FormControl autoFocus placeholder={"Enter Uid"} type="text" onChange={this.handleTransUid.bind(this)}></FormControl>
        </div>
    }

    handleTransUid(e) {
        this.transUid = e.target.value;
    }

    appliedChanges(){
        this.setState({appliedChanges: true});
    }

    renderApply() {
        return React.createElement(Button, {
            onClick: function () { TranslationService.performUpdate();
                                    this.appliedChanges(); }.bind(this),
            bsStyle: 'primary',
            className: "btn-block",
        }, "Apply Changes");
    }

    renderChangeOverview() {
        return React.createElement(Button, {
            onClick: this.showUnappliedTranslations.bind(this),
            bsStyle: 'primary',
            className: "btn-block",
        }, "View Unapplied Changes");
    }

    renderDownload() {

        return <button onClick={this.downloadTable.bind(this)}
         type="button" className="btn btn-icon command-delete waves-effect waves-circle" data-row-id="10253"><span className="zmdi zmdi-download"></span></button>
    }

    showUnappliedTranslations() {
        TranslationService.getUnappliedChanges();
        this.setState({
            showUnappliedChanges: true
        });
    }

    handleUid(e) {
        this.uid = e.target.value;
    }

    handleSearch(e) {
        this.search = e.target.value;
    }

    exitEdit() {
        this.setState({
            editObj: undefined,
            edit: false
        })
    }

    edit(obj) {
        this.setState({
            editObj: obj,
            edit: true
        })
    }

    exitNewTranslation() {
        this.setState({
            newTranslation: false
        })
    }

    exitNewTranslationExisiting() {
        this.setState({
            newTranslationExisiting: false
        })
    }

    exitAppliedChange() {
        this.setState({
            appliedChanges: false
        })
    }


    addNewTranslationFunction() {
        this.setState({
            newTranslation: true
        })
    }

    addNewTranslationFunctionExisitngUid() {
        this.setState({
            newTranslationExisiting: true
        })
    }


    renderBody() {
        return <div>

            <Modal show={this.state.edit} onHide={this.exitEdit.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-10">
                        <TranslationEdit translation={this.state.editObj} table={this.typeOption} submit={this.exitEdit.bind(this)} ></TranslationEdit>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={this.state.newTranslation} onHide={this.exitNewTranslation.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-10">
                        <InsertTranslation onSubmit={this.exitNewTranslation.bind(this)} languages={this.langSelect} ></InsertTranslation>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={this.state.appliedChanges} onHide={this.exitAppliedChange.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-10">
                        CHANGES APPLIED
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={this.state.newTranslationExisiting} onHide={this.exitNewTranslationExisiting.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-10">
 
                        <AddTranslation uid={this.transUid} onSubmit={this.exitNewTranslationExisiting.bind(this)} ></AddTranslation>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={this.state.newTransPopUp} onHide={this.hidePopUp.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-10">

                        {"New Translation added: UID: " + this.state.newTranslationUid}
                        
                    </div>
                </Modal.Body>
            </Modal>


            <Row>
                <Col sm={6}> {this.renderTranslationAdding()}</Col>
            </Row>
            <p></p><p></p>
            <Row>
                <FormattedMessage id={'ui-99999999'} defaultMessage={'Search for Translations'} />
            </Row>
            <p></p> <p></p> <p></p>
            <Row>
                {this.renderFilters()}
            </Row>

            <p></p>

            <Row>
                <Col sm={6}><FormControl autoFocus placeholder={"Enter Uid"} type="text" onChange={this.handleUid.bind(this)} /></Col>
                <Col sm={6}><FormControl autoFocus placeholder={"Enter Search Term"} type="text" onChange={this.handleSearch.bind(this)} /></Col>
            </Row>

            <p></p> <p></p> <p></p>

            <Row>
                <Col sm={6}> {this.renderSelect()}</Col>

            </Row>

            <p></p> <p></p> <p></p>
            <Row>
                <FormattedMessage id={'ui-99999999'} defaultMessage={'Manage Edits'} />
            </Row>
            <p></p> <p></p> <p></p><p></p> <p></p> <p></p><p></p> <p></p> <p></p>
            <Row>
                <Col sm={6}> {this.renderApply()}</Col>
                <Col sm={6}> {this.renderChangeOverview()}</Col>
            </Row>

            <p></p>
            <p></p>
            <p></p>
            <p></p>


            <Row>
                <Col sm={6}> {this.renderDownload()}</Col>
            </Row>


            <p></p>
            {this.renderLoading()}
            <Row className="p-b-20">
                {this.renderVocabTable()}
            </Row>

            <Row className="p-b-20">
                {this.renderUnappliedChanges()}
            </Row>

        </div>
    }

    hidePopUp(){
        TranslationStore.newTranslationUid = undefined;
        this.setState({
            newTransPopUp: false,
            newTranslationUid: undefined
        })
    }

    processTranslationAction(e){
        var type = e.value;
        if (type == 'Add New Translation'){
            this.addNewTranslationFunction();
        } else {
            this.addNewTranslationFunctionExisitngUid();
        }
    }

    renderTranslationAdding(){

        var transOptions = ['Add New Translation', 'Add Translation for Exisiting UID'];

        
        transOptions = transOptions.map(function (type) {
            return { value: type, label: type }
        });

        return <div> <Select onChange={this.processTranslationAction.bind(this)} options={transOptions} value={transOptions[0]} noResultsText={<FormattedMessage id={"ui-2011"} defaultMessage={"No Results Found"} />}
        placeholder={<FormattedMessage id={'ui-99999999'} defaultMessage={'Add Translation Options'} />} /></div>
      
    }

    renderLoading() {
        if (this.state.isLoading) {
            return <div><center><font size="+10">LOADING</font></center></div>
        } else {
            return <div> </div>
        }
    }

    cancel(e) {
        TranslationService.deleteTranslation(e);
    }

    sortByWord() {
        if (this.state == undefined) return;
        var newD = this.state.data.sort(function (a, b) {
            return a.text[0] > b.text[0];
        });
        this.setState({ data: newD });
    }

    renderUnappliedChanges() {
        if (this.state.showUnappliedChanges) {
            return <UpdateTable ref={(updateTableRef) => this.updateTable = updateTableRef} edit={this.edit.bind(this)} delete={this.cancel.bind(this)} changes={this.state.unappliedChanges} />
        } else {
            return <div></div>
        }
    }

    renderVocabTable() {
        if (!this.state.showUnappliedChanges) {
            return <TranslationTable ref={(transTableRef) => this.table = transTableRef} edit={this.edit.bind(this)} vocab={this.state.data} sortByWord={this.sortByWord.bind(this)} setLive={this.setLive.bind(this)} />
        } else {
            return <div></div>
        }
    }

    setLive(obj, isLive) {
        TranslationService.setLive(obj.uid, isLive, this.typeOption);
    }

    downloadTable(){
        (new Download()).export_table_to_csv();
    }

    render() {
        return <div>
            <Card>
                <CardHeader>
                    <FormattedMessage id={'ui-9999'} defaultMessage={'Translation System'} />
                </CardHeader>
                <CardBody >
                    {this.renderBody()}
                </CardBody>
            </Card>
        </div>
    }
}




// WEBPACK FOOTER //
// ./src/components/translation-system.js